import { http } from '@/http/axios.js';

// 用户列表
export function getListAPI(params) {
  return http({
    url: '/adminapi/member/page',
    method: 'get',
    params
  })
}
// 加入名单
export function addRosterAPI(data) {
  return http({
    url: '/adminapi/roster/add',
    method: 'post',
    data
  })
}
